__webpack_require__.p = "https://ux-pool-test.azurewebsites.net/";